import {
  Input,
  OnInit,
  Output,
  Component,
  OnChanges,
  ElementRef,
  EventEmitter,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'dropdown-number',
  templateUrl: './dropdown-number.component.html',
  styleUrls: ['./dropdown-number.component.scss'],
  host: { '(document:click)': 'onClick($event)' }
})
export class DropdownNumberComponent implements OnInit, OnChanges {

  // Inputs variables
  @Input() items: any[];
  @Input() label: string;
  @Input() width: string;
  @Input() selected: any | null = null;
  @Input() min: number;
  @Input() max: number;

  // Output variables
  @Output() onItemSelect: EventEmitter<any> = new EventEmitter<any>();

  // Dropdown open status
  public dropdownOpened: boolean = false;
  // Selected item
  public itemSelected: number | null;

  // Constructor
  constructor(private _eref: ElementRef) { }

  // On component init
  ngOnInit() {
    this.itemSelected = (this.selected) ? this.selected.text : (this.items && this.items.length > 0) ? this.items[0].text : null;
  }

  // On component do check
  ngOnChanges(changes: SimpleChanges) {
    // Prevent change
    if (changes.selected && changes.selected.currentValue.text !== this.itemSelected) {
      this.itemSelected = changes.selected.currentValue.text;
    }
  }

  // On element click
  public onClick(event): void {
    if (!this._eref.nativeElement.children[0].children[0].contains(event.target) && this.dropdownOpened) this.dropdownOpened = false;
  }

  // Selecting an item
  public itemSelect(item): void {
    this.itemSelected = item.text;
    this.onItemSelect.emit(item);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-number/dropdown-number.component.ts